import { FirebaseError } from 'firebase/app';

export class ReportError extends Error {
  constructor(message: string, public code?: string) {
    super(message);
    this.name = 'ReportError';
  }

  static fromFirebaseError(error: FirebaseError): ReportError {
    const messages: Record<string, string> = {
      'permission-denied': 'You do not have permission to access this report.',
      'not-found': 'Report not found. Please ensure all evaluations are completed.',
      'unavailable': 'Network error. Please check your connection and try again.',
      'invalid-argument': 'Invalid report request. Please try again.',
      'failed-precondition': 'Report cannot be accessed at this time.'
    };

    return new ReportError(
      messages[error.code] || 'An unexpected error occurred while loading your report',
      error.code
    );
  }
}

export function handleReportError(error: unknown): never {
  if (error instanceof FirebaseError) {
    throw ReportError.fromFirebaseError(error);
  }

  if (error instanceof Error) {
    throw new ReportError(error.message);
  }

  throw new ReportError('Failed to load report data');
}